<div style="width:200px;">
    <mat-dialog-content>
        <span style="white-space:pre-line;">Admin Settings Password</span>
        <mat-form-field>
            <input matInput type="password" [(ngModel)]="password" (keypress.enter)="checkPassword()" />
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" mat-dialog-close tabindex="-1" (click)="checkPassword()">OK</button>
    </mat-dialog-actions>
</div>